import _ from 'lodash'
import values from 'core/data-model/constants/values'
import { getToggles } from 'quick-quote/feature-toggles'

export const getRiskLevel = () => {
  return require('core/service/data-config/investment/risk-level.json')
}

export const calculateRiskLevel = (score, riskLevel) => {
  const risk = _.find(riskLevel, (r) => score >= r.minScore && score <= r.maxScore)
  const value = _.get(risk, 'value', 0)
  const label = _.get(risk, 'label', '')
  const description = getToggles().ENABLE_RPQ_FORM_2022
    ? _.get(risk, 'descriptionV2', '')
    : _.get(risk, 'description', '')

  return {
    value,
    label,
    isEvaluated: true,
    description,
  }
}

export const calculateAcceptableRiskRange = (riskEvaluated, riskItems) => {
  const acceptableRiskLevels = riskItems.filter((riskItem) => riskItem.value <= riskEvaluated.value)
  return {
    min: _.min(_.map(acceptableRiskLevels, 'value')),
    max: _.max(_.map(acceptableRiskLevels, 'value')),
  }
}

export const calculateOverRiskRange = (riskEvaluated, riskItems) => {
  const acceptableRiskLevels = riskItems.filter((riskItem) => riskItem.value > riskEvaluated.value)
  return isMostRiskyRisk(riskEvaluated, riskItems)
    ? null
    : {
        min: riskEvaluated.value + 1,
        max: _.max(_.map(acceptableRiskLevels, 'value')),
      }
}

export const isMostRiskyRisk = (riskEvaluated, riskItems) => {
  const mostRiskyRisk = _.maxBy(riskItems, 'value')
  return riskEvaluated.value >= mostRiskyRisk.value
}

export const getRiskColor = (riskLevel) => {
  return values.RISK_LEVEL_COLORS[riskLevel]
}

export const getAllRiskColors = () => {
  return Object.keys(values.RISK_LEVEL_COLORS).map((level) => ({
    level: parseInt(level),
    color: values.RISK_LEVEL_COLORS[level],
  }))
}
